(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4806],{

/***/ 30068:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/policies/checkout",
      function () {
        return __webpack_require__(39911);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 39911:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_ui_MetaTag__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42031);



var CheckoutPolicyPage = function() {
    var companyName = "https://anthu.vn";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_MetaTag__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                title: "CH\xcdNH S\xc1CH KIỂM H\xc0NG",
                description: "CH\xcdNH S\xc1CH KIỂM H\xc0NG"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "container tw-mx-auto md:tw-border-t tw-border-primary-main tw-pt-8 tw-pb-10",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "tw-flex tw-gap-y-1 tw-flex-col tw-leading-7",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                            className: "tw-text-center tw-font-bold tw-text-lg lg:tw-text-2xl tw-mb-5 tw-uppercase",
                            children: "Ch\xednh s\xe1ch kiểm h\xe0ng"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "tw-leading-7 tw-flex tw-flex-col tw-gap-y-2",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                    className: "tw-font-semibold tw-text-primary-main ",
                                    children: "1. Định nghĩa:"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                    children: [
                                        "Kiểm h\xe0ng l\xe0 thực hiện c\xe1c c\xf4ng việc kiểm tra v\xe0 so s\xe1nh c\xe1c sản phẩm/h\xe0ng h\xf3a nhận được trong kiện h\xe0ng nhận từ ",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                                            children: companyName
                                        }),
                                        " với c\xe1c sản phẩm hiển thị ở từng link sản phẩm trong đơn h\xe0ng (Kh\xe1ch đ\xe3 đặt) tr\xean ",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                                            children: companyName
                                        }),
                                        ". Số lượng, m\xe0u sắc, k\xedch cỡ, th\xf4ng số kỹ thuật..."
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                    className: "tw-font-semibold tw-text-primary-main ",
                                    children: "2. Quy định:"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "tw-font-semibold",
                                    children: "* Thời gian kiểm h\xe0ng:"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: "Ngay khi sản phẩm được giao tới kh\xe1ch h\xe0ng."
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "tw-font-semibold",
                                    children: "* Phạm vi kiểm tra h\xe0ng h\xf3a:"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                    children: [
                                        "- ",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                                            children: companyName
                                        }),
                                        " thực hiện việc kiểm đếm số lượng sản phẩm được đặt h\xe0ng tr\xean ",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                                            children: companyName
                                        }),
                                        " ",
                                        "(theo c\xe1c lần ph\xe1t h\xe0ng), đối chiếu, so s\xe1nh c\xe1c sản phẩm sẽ giao với sản phẩm đ\xe3 đặt tr\xean đơn theo c\xe1c ti\xeau ch\xed:"
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                    className: "tw-ps-2",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: "+ Theo c\xe1c thuộc t\xednh cơ bản ph\xe2n loại h\xe0ng h\xf3a m\xe0 Kh\xe1ch h\xe0ng đ\xe3 thao t\xe1c click chọn nhập h\xe0ng khi đưa v\xe0o giỏ h\xe0ng."
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: "+ Theo mẫu m\xe3 được hiển thị bởi ảnh đại diện của sản phẩm được lưu khi đặt h\xe0ng."
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                            children: [
                                                "+ ",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                                                    children: companyName
                                                }),
                                                " kiểm tra c\xe1c lỗi ph\xe1t hiện nhanh bằng mắt thường như r\xe1ch/thủng/g\xe3y c\xe1c mảng lớn, nhưng kh\xf4ng cam kết ph\xe1t hiện c\xe1c lỗi kỹ thuật."
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: "- Để kiểm tra h\xe0ng h\xf3a, ch\xfang t\xf4i phải mở sản phẩm trước sự chứng kiến của qu\xfd kh\xe1ch h\xe0ng. Nếu c\xf3 nhu cầu giữ nguy\xean hộp/tem/seal…của h\xe0ng h\xf3a, Qu\xfd kh\xe1ch vui l\xf2ng ghi ch\xfa tr\xean đơn để nh\xe2n vi\xean kiểm h\xe0ng nắm th\xf4ng tin. Khi đ\xf3, Ch\xfang t\xf4i sẽ chỉ hỗ trợ khiếu nại nếu h\xe0ng h\xf3a b\xean trong c\xf3 sự sai kh\xe1c. C\xe1c bước kiểm h\xe0ng"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                    children: [
                                        "- Khi Qu\xfd kh\xe1ch nhận h\xe0ng, vui l\xf2ng l\xe0m theo c\xe1c bước dưới đ\xe2y để được hỗ trợ tốt nhất trong trường hợp đơn h\xe0ng ph\xe1t sinh một trong c\xe1c lỗi sau: Kh\xf4ng đ\xfang chủng loại, sai số lượng, k\xedch thước, m\xe0u sắc,…",
                                        " "
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                                            children: "Bước 01:"
                                        }),
                                        " Qu\xfd kh\xe1ch quay video qu\xe1 tr\xecnh mở h\xe0ng, kiểm tra h\xe0ng h\xf3a nhằm mục đ\xedch kiểm tra số lượng, kiểm tra ph\xe2n loại sản phẩm tr\xf9ng khớp với tr\xean h\xf3a đơn. Qu\xe1 tr\xecnh quay video ghi lại th\xf4ng tin gồm: M\xe3 đơn h\xe0ng, người gửi, người nhận,…của đơn h\xe0ng."
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                                            children: "Bước 02:"
                                        }),
                                        " Qu\xfd kh\xe1ch vui l\xf2ng li\xean hệ trực tiếp số điện thoại Hotline: 03.3333.6789 th\xf4ng b\xe1o lỗi ph\xe1t sinh xảy ra với đơn h\xe0ng của Qu\xfd kh\xe1ch. Việc giải quyết y\xeau cầu khiếu nại của Qu\xfd kh\xe1ch sẽ được bộ phận xử l\xed khiếu nại của ",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                                            children: companyName
                                        }),
                                        " xử l\xed. C\xe1c y\xeau cầu khiếu nại sẽ được ch\xfang t\xf4i ph\xe2n loại v\xe0 xử l\xed theo từng trường hợp cụ thể, nhằm mục đ\xedch hỗ trợ Qu\xfd kh\xe1ch được nhanh nhất"
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (CheckoutPolicyPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(30068); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);